import { AppStateType } from '@lib/core/service/types/appStateType';

export const selectServiceInstanceProductCategory = (state: AppStateType, defaultValue = ''): string =>
  state?.service?.serviceInstance?.serviceInstanceProductCategory || defaultValue;

export const selectServiceInstanceRetailerLocationId = (state: AppStateType, defaultValue = ''): string =>
  state?.service?.serviceInstance?.serviceInstanceRetailerLocationId || defaultValue;

export const selectServiceInstanceRetailerSlug = (state: AppStateType, defaultValue = ''): string =>
  state?.service?.serviceInstance?.serviceInstanceRetailerSlug || defaultValue;

export const selectServiceInstanceRetailerLocationSlug = (state: AppStateType, defaultValue = ''): string =>
  state?.service?.serviceInstance?.serviceInstanceRetailerLocationSlug || defaultValue;

export const selectServiceInstanceRetailerType = (state: AppStateType) =>
  state.service.serviceInstance.serviceInstanceType;

export const selectIsServiceInstanceFeatureEnabled = (state: AppStateType, defaultValue = false): boolean =>
  (!!selectServiceInstanceProductCategory(state) &&
    !!selectServiceInstanceRetailerLocationId(state) &&
    !!selectServiceInstanceRetailerSlug(state)) ||
  defaultValue;

export const selectIsServiceInstanceRetailerDataLoading = (state: AppStateType, defaultValue = false): boolean =>
  state?.service?.serviceInstance?.retailer?.isLoading || defaultValue;

export const selectServiceInstanceRetailerLogo = (state: AppStateType, defaultValue = ''): string =>
  state?.service?.serviceInstance?.retailer?.data?.tags?.headerLogo || defaultValue;
